import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
var CardBody = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.size.spacing.large.value;
});
export { CardBody };